import { ISocialNetworkRepository } from '../../../domain/repositories/social-network.repository.interface';
import { SocialNetwork } from '../../../domain/entities/social-network.entity';

export class GetSocialNetworkByIdUseCase {
  constructor(private readonly repository: ISocialNetworkRepository) {}

  public async execute(id: string): Promise<SocialNetwork> {
    return this.repository.getById(id);
  }
}
